<template>
  <div>
		<div class="mt-5 pt-4">
      <nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Library</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Video</li>
        </ol>
      </nav>

      <div class="mt-4">
				<div class="row">
					<div class="col-md-12">
						<div class="card shadow p-3 mb-5 bg-white rounded border-0">
							<div class="card-body">

                <div class="row mb-4">
                  <div class="col-12">
                    <div class="text-center" style="padding:10%;" v-if="!videoLoaded">
                      <img src="@/assets/img/loading.svg" v-if="loading">
                      <h1 v-if="!loading && !videoLoaded" class="text-default" >Unable to play the video.</h1>
                    </div>
                    <div class="videoContent" v-if="!loading && videoLoaded">
                      <video-player :options="playerOptions" :playsinline="true"/>
                    </div>
                  </div>
                  <div class="col text-default text-center mt-3" v-if="!loading">
                    <h6 style="font-size:14px;"><strong>{{videoName}}</strong></h6>
                    <h6 style="font-size:14px;">Added: <strong>{{videoAdded}}</strong></h6>
                  </div>
                </div>

                <div class="row mb-5">
                  <div class="col"></div>
                  <div class="col-lg-8 col-md-8 col-xs-8 mt-2" v-if="!loading">
                    <carousel :items-to-show="2.5" :wrap-around="true" class="player-nav" :breakpoints="breakpoints">
                      <slide v-for="(video, index ) in videos" :key="index">
                        <div class="square" @click="playVideo(video.ID)">
                          <img class="img-fluid align-middle carousel__item" :src="video.thumbnail" style="max-width:100%; max-height: 100%;">
                        </div>
                      </slide>

                      <template #addons>
                        <navigation />
                      </template>
                    </carousel>
                  </div>
                  <div class="col"></div>
                </div>

                <div class="mt-5">
                  <button type="button" class="btn btn-outline-secondary" @click="$router.go(-1)">Back</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import moment from 'moment';


export default {
  components: {
    VideoPlayer,
    Carousel,
    Slide,
    Navigation,
  },

  data () {
    return {
      videoLoaded: false,

      // videojs options
      playerOptions: {
        fluid: true,
        width: '840',
        height: '264',
        autoplay: false,
        controls: true,
        muted: false,
        language: 'en',
        sources: [{
            type: "video/mp4",
            src:"https://storage.googleapis.com/video-core-uat/Dyl4cY37qpUWold6bD0lL09cRW37u5LncyporJtFHbaYwqycwUKJlrBRRCG4DUbpaNjp2YjaLTUUniQkCwszN0byrHzXHMpo0Kn1OQMBYroB6JJY5uXlZGCjQ1pAViDL",
        }],
        tracks: [],
        poster: "https://storage.googleapis.com/video-core-uat/patching thumbnail.JPG",
        playbackRates: [0.5, 1, 1.5, 2],
        textTrackSettings: false,
        html5: {nativeTextTracks: false}
      },

      breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 2.5,
        snapAlign: 'center',
      },
      // 1024 and up
      958: {
        itemsToShow: 3,
        snapAlign: 'start',
      },
      // 1024 and up
      1024: {
        itemsToShow: 4,
        snapAlign: 'start',
      },

      videos: [],
      loading: false,
      videoName: null,
      videoAdded: null,
    },

    }
  },

  async created() {
    await this.getData();
  },

  methods: {
    getData() {
      this.loading = true;

      this.$axios.get('/supadmin/trainings/videos?' + 'filter=')
      .then((response) => {
          if (response.data.success){
            this.videos = response.data.training_videos;
            this.setVideo(this.$route.params.id, false)
          } else {
            this.$toast.error(response.data.message)
          }

        this.loading = false;
      })
      .catch()
    },

    async getCaptionsByVideoID(id){
      return this.$axios.get('/trainings/users/'+ this.$store.state.auth.jwtPayload.user_id +'/videos/'+ id +'/captions')
        .then((response) => {
          if (response.data.success){
            let tempData = []
            for (const caption of response.data.captions) {
                  let data = {
                    kind: "captions",
                    label: caption.label,
                    srclang: caption.source_lang,
                    src: caption.source_url,
                }
                tempData.push(data)
            }

            if (tempData.length == 0)
                this.playerOptions.tracks = null

            this.playerOptions.tracks = tempData
            return true
          } else {
            this.$toast.error(response.data.message)
            return false
          }
        })
        .catch()
    },

    setVideo(id, autoplay){
      this.videos.forEach(async v => {
        if (id == v.ID) {

          await this.getCaptionsByVideoID(id)
          this.playerOptions.sources[0].src = v.url;
          this.playerOptions.poster = v.thumbnail;

          this.video = v
          this.videoLoaded = true

          this.videoName = this.video.name
          this.videoAdded =  moment(this.video.CreatedAt).format('LL');

          if(autoplay)
            this.playerOptions.autoplay = true
      }
      });

      this.loading = false;
    },

    playVideo(id){
      this.loading = true;
      this.videoLoaded = false;

      setTimeout(() => {
        this.setVideo(id, true)

      }, 500);
    }
  },
}

</script>

<style scoped>
  .videoContent {
    max-width: 900px;
    margin: auto;
  }

  .card-body-scroll {
    min-width: 300px;
    max-width: 200px;
    margin-right: 5px;
  }

  .text-default{
    color: #435666;
  }

  .carousel__next{
    color: #ffffff;
    background:#00a0c1;
    margin-left:600px;
  }

  .carousel__prev{
    color: #ffffff;
    background:#00a0c1;
  }

  .carousel__prev .carousel__icon {
    /* margin-right:20px; */
  }

  .carousel__next .carousel__icon {
    /* margin-left:20px; */
  }
  .carousel__icon {
    width:20px;
    height:20px;
  }

  .player-nav {
    margin:auto;
  }

  @media only screen and (max-width: 600px) {
    .carousel__prev .carousel__icon {
      margin-right:50px;
    }

    .carousel__next .carousel__icon {
      margin-left:50px;
    }
    .carousel__icon{
      width:50px;
      height:50px;
    }

    .carousel__item {
     width:30px;
    }

    .player-nav{
      margin-top: 20%;
    }
  }

  .square {
    width: 150px;
  }

</style>